import fetchService from "../../../services/fetchService";
import { FETCH_CONTACT, FETCH_CONTACTS } from "../types";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchContactsData = (page) => async (dispatch) =>
  await dispatch({
    type: FETCH_CONTACTS,
    message: `All contact messages data`,
    payload: fetchService(`${baseUrl.backend}/api/messages?page=${page}&limit=10`),
  });

  export const fetchMessage = (id) => async (dispatch) => await dispatch({
    type: FETCH_CONTACT,
    message: `message retrieved`,
    payload: fetchService(`${baseUrl.backend}/api/messages/${id}`)
  });
